<template>
    <!--    <b-container class="resitev-container" fluid>-->
    <b-row class="resitev-container">

        <div class="iskalnik">
            <div class="input-group md-form form-sm form-2 pl-0">
                <input class="form-control my-0 py-1 lime-border" type="text" placeholder=""
                       aria-label="Search">
                <div class="input-group-append">
    <span class="input-group-text lime lighten-2" id="basic-text1"><i class="fas fa-search text-grey"
                                                                      aria-hidden="true"></i></span>

                </div>
            </div>
        </div>
        <div style="display: inline-block; width: 100%">
            <b-row>
                <b-col col lg="5">
                    <div v-for="item in getDomains" v-bind:key="item.text" class="domains">
                        <div style="width: auto"></div>
                        <img :src="item.src" class="domains-img">
                        <p class="domain-desc">{{item.title}}</p>
                    </div>
                </b-col>
                <b-col style="display: inline-block; vertical-align: middle; height:  100%">
                    <img src="/pic/resitve/pametna_skupnost_img.png" id="pametnaMestaInSKupnosti" style="margin-top: 50px; max-width: 80%"/>
<!--                    <div class="doughnut"-->
<!--                         v-bind:style="{ height: doughnutHeight, borderRadius: borderRadius, borderWidth: borderWidth }"-->
<!--                         id="doughnut"></div>-->
                </b-col>
            </b-row>
        </div>
    </b-row>
    <!--    </b-container>-->
</template>

<script>
    import presentation from "./../../../components/data/presentation";

    export default {
        name: "PmisResitevSearchContainer",
        computed: {
            getDomains() {
                JSON.stringify("test: " + presentation["resitve"].domains);
                return presentation.resitve.domains;
            },
        },
        data() {
            return {
                doughnutHeight: "0px",
                borderRadius: "0px",
                borderWidth: ""
            }
        },
        mounted() {
            /*
            var elem = document.getElementById("doughnut");
            var cw = elem.offsetWidth;
            this.doughnutHeight = cw + "px";
            this.borderRadius = cw / 2 + "px";
            this.borderWidth = cw / 20 + "px"

            var cw5 = cw / 4;
            var cw55 = 0;
            var cw44 = cw / 2;
            var boost = cw / 5;
            var circle = 'background-color: yellow;border-radius: 50%;\n' +
            '        height: '+cw5+'px; width: '+cw5+'px;opacity:70%';
            for (var i = 0; i < 5; i++) {
                elem.innerHTML += '<div style="position: absolute; left: ' + cw55 + 'px; top: ' + cw44 + (i%2 == 1 ? boost : "") + 'px; '+circle+'">+</div>';
                if (i > 0 && i < 4)
                    elem.innerHTML += '<div style="position: absolute; left: ' + cw55 + 'px; top: ' + (cw - cw44)  + 'px; '+circle+'">+</div>';
                cw55 += cw5;
                if (i > 5 / 2 - 1) {
                    cw44 += cw5;
                } else {
                    cw44 -= cw5;
                }

            }
            */
        }
    }

</script>

<style lang="scss" scoped>
    .domain-desc {
        display: inline;
        font-family: "Roboto";
        font-size: 1.4em;
        color: $pmis-grey;
        margin-left: 10px;
    }

    .doughnut {
        margin: 25px;
        border: solid $expose;
        opacity: 20%;
        width: 70%;
    }

    .resitev-container {
        padding: 20px;
        background-color: #e6f4ec;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .iskalnik {
        /*margin: 20px;*/
        display: inline-block;
        width: 25%;
        min-width: 250px;
    }

    .domains {
        vertical-align: middle;
        margin-left: 5em;
        margin-bottom: 2em;
    }

    .domains-img {
        /*margin-left: 5em;*/
        max-width: 100px;
    }

    .dot {
        background-color: #456BD9;
        border: 0.1875em solid #0F1C3F;
        border-radius: 50%;
        box-shadow: 0.375em 0.375em 0 0 rgba(15, 28, 63, 0.125);
        height: 100px;
        width: 100px;

    }
</style>
